import html from "../images/technologies/html.svg";
import css from "../images/technologies/css.svg";
import javascript from "../images/technologies/js.svg";
import typescript from "../images/technologies/ts.svg";
import react from "../images/technologies/react.svg";
import redux from "../images/technologies/redux.svg";
import mui from "../images/technologies/mui.svg";
import tailwind from "../images/technologies/tailwind.svg";
import node from "../images/technologies/node.svg";
import express from "../images/technologies/express.svg";
import mongoDB from "../images/technologies/mongo.svg";
import postgreSQL from "../images/technologies/firebase.svg";
import aws from "../images/technologies/aws.svg";
import firebase from "../images/technologies/firebase.svg";
import git from "../images/technologies/git.svg";
import npm from "../images/technologies/npm.svg";
import jest from "../images/technologies/jest.svg";
import { nanoid } from "nanoid";

const technologyList = [
  { id: 1, name: "HTML", image: html },
  { id: 2, name: "CSS", image: css },
  {id: 3, name: "JavaScript", image: javascript},
  {id: 4, name: "TypeScript", image: typescript},
  {id: 5, name: "React", image: react},
  {id: 6, name: "Redux", image: redux},
  {id: 7, name: "Material UI", image: mui},
  {id: 8, name: "Tailwind CSS", image: tailwind},
  {id: 9, name: "Node", image: node},
  {id: 10, name: "Express", image: express},
  {id: 11, name: "MongoDB", image: mongoDB},
  {id: 12, name: "PostgreSQL", image: postgreSQL},
  {id: 13, name: "AWS", image: aws},
  {id: 14, name: "Firebase", image: firebase},
  {id: 15, name: "GIT", image: git},
  {id: 16, name: "NPM", image: npm},
  {id: 17, name: "Jest", image: jest},
];

export default technologyList